/**
 * 获取触摸点或鼠标点的信息
 * 如果传入的是 touch 事件，返回第一个触摸点的信息
 * 否则返回事件对象，其中包含鼠标的信息
 * @param event
 * @returns
 */
export function getTouchOrMouseInfo(event: Event) {
    if (isTouchEvent(event)) {
        return event.changedTouches[0];
    }
    return event as MouseEvent;
}

export function isTouchEvent(event: Event): event is TouchEvent {
    return 'changedTouches' in event;
}
